import { DATA_BINDING } from '@wix/app-definition-ids'
import type { PageRef } from '@wix/editor-platform-sdk-types'
import {
  addOrUpdateRouterWithPattern,
  type AppApi,
} from '@wix/wix-data-client-common'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import type { Schema } from '@wix/wix-data-schema-types'
import { prepareDataForBlankPageEditor3 } from '../add-blank-dynamic-page-editor3/prepareDataForBlankPageEditor3'

export const convertPageToDynamicEditor3 = async ({
  editorSdkProxy,
  appApi,
  pageRef,
  schema,
}: {
  editorSdkProxy: EditorSDK
  appApi: AppApi
  pageRef: PageRef
  schema: Schema
}) => {
  const { routeDefinition, routerPrefix, pattern } =
    await prepareDataForBlankPageEditor3({ editorSdkProxy, appApi, schema })

  const routerRef = await addOrUpdateRouterWithPattern(
    editorSdkProxy,
    routerPrefix,
    pattern,
    routeDefinition,
  )

  await editorSdkProxy.routers.pages.connect({
    routerRef,
    pageRef,
    pageRoles: [routeDefinition.pageRole],
  })

  await editorSdkProxy.document.pages.data.update({
    pageRef,
    data: {
      parentPageId: undefined,
      managingAppDefId: DATA_BINDING,
      pageUriSEO: '',
    },
  })
}
